import { render } from "./ResidentsView.vue?vue&type=template&id=0e99ad3c"
import script from "./ResidentsView.vue?vue&type=script&lang=js"
export * from "./ResidentsView.vue?vue&type=script&lang=js"

import "./ResidentsView.vue?vue&type=style&index=0&id=0e99ad3c&lang=scss"
script.render = render

export default script